export const DEFAULT_OPERATIONAL_CURRENCY = 'CAD';

export const SUPPORTED_INVOICE_CURRENCIES = Object.freeze([
  Object.freeze({ code: 'CAD', label: 'Canadian dollar (CAD)' }),
  Object.freeze({ code: 'USD', label: 'United States dollar (USD)' }),
  Object.freeze({ code: 'AUD', label: 'Australian dollar (AUD)' }),
  Object.freeze({ code: 'EUR', label: 'Euro (EUR)' }),
]);

const SUPPORTED_CODES = new Set(SUPPORTED_INVOICE_CURRENCIES.map(({ code }) => code));

export function validateInvoiceCurrency(value) {
  const currency = String(value || '').trim().toUpperCase();
  if (!SUPPORTED_CODES.has(currency)) {
    throw new Error('Currency must be one of CAD, USD, AUD, or EUR.');
  }
  return currency;
}

export function normalizeOperationalCurrency(value) {
  try {
    return validateInvoiceCurrency(value);
  } catch {
    return DEFAULT_OPERATIONAL_CURRENCY;
  }
}
